module.exports = __webpack_public_path__ + "img/sld_scb_1_t1_green.7b189f26.svg";